import { ordersCollectionModel } from "../../models/ordersModel";
import { ReadOnlyProps } from "../../utils/templates";

interface props {
  operationsList: Array<ordersCollectionModel>;
  isOperationsListLoaded: boolean;
  selectedContainer: ordersCollectionModel;
  isOperationsTableRefreshed: boolean;
  allowedRolesForOperations: Array<string>;
  shippingMethodList: Array<Record<string, string>>;
  paymentTerms: Array<Record<string, string>>;
  shipToList: Array<Record<string, string>>;
  orderTypeList: Array<Record<string, string>>;
  locationsList: Array<Record<string, string>>;
  loadingHubspot: boolean;

  productFlagsChoices: Array<Record<string, string>>;
  sapDocTypeChoices: Array<Record<string, string>>;
  artworkApprovedChoices: Array<Record<string, string>>;
  containerSizeChoices: Array<Record<string, string>>;

  operationUsersList: Array<Record<string, string>>;
  isOperationUsersLoaded: boolean;

  isAttachmentsLoaded: boolean;
  operationAttachmentsList: Array<Record<string, string>>;

  operationAuditConfig: any;
}

export const operationsState: ReadOnlyProps<props> = {
  //Filled via dynamic stream
  operationsList: [],
  isOperationsListLoaded: false,
  selectedContainer: {} as unknown as ordersCollectionModel,
  isOperationsTableRefreshed: false,
  loadingHubspot: false,

  // Operation Users
  operationUsersList: [],
  isOperationUsersLoaded: false,

  // attachments
  isAttachmentsLoaded: false,
  operationAttachmentsList: [],

  // Operation Audit For a specific order
  operationAuditConfig: {
    isOperationHistoryLoaded: false,
    operationHistoryList: [],
    totalCount: null,
    totalPages: null,
    pageSize: 10,
    page: 1,
    sort: {
      key: "modifiedAt",
      direction: "desc",
    },
    status: "all",
  },

  //Constants
  allowedRolesForOperations: ["OWNER", "ADMIN", "MANAGER", "OPERATION"],
  shippingMethodList: [
    {
      key: "",
      value: "--",
    },
    {
      key: "pick_up",
      value: "Pick Up",
    },
    {
      key: "local_delivery",
      value: "Local Delivery",
    },
    {
      key: "customer_pay",
      value: "Customer Pay",
    },
    {
      key: "free_shipping",
      value: "Free Shipping",
    },
    {
      key: "request_for_freight_quote",
      value: "Request For Freight Quote",
    },
    {
      key: "our_truck",
      value: "Our Truck (QLD Only)",
    },
    {
      key: "direct_ship",
      value: "Direct Ship (FCL Only)",
    },
  ],
  paymentTerms: [
    {
      key: "",
      value: "--",
    },
    {
      key: "net_15",
      value: "Net 15",
    },
    {
      key: "net_30",
      value: "Net 30",
    },
    {
      key: "net_45",
      value: "Net 45",
    },
    {
      key: "net_60",
      value: "Net 60",
    },
    {
      key: "net_90",
      value: "Net 90",
    },
    {
      key: "prepaid",
      value: "Prepaid",
    },
    {
      key: "creditcard",
      value: "Credit Card",
    },
    {
      key: "eft",
      value: "EFT / Bank Transfer",
    },
    {
      key: "cod",
      value: "Pay on Delivery (COD)",
    },
    {
      key: "mbp",
      value: "Milestone-Based Payment",
    },
    {
      key: "other",
      value: "Other",
    },
  ],
  shipToList: [
    {
      key: "",
      value: "--",
    },
    {
      key: "melbourne_berries",
      value: "Melbourne Berries",
    },
    {
      key: "nsw_berries",
      value: "NSW Berries",
    },
    {
      key: "perth_berries",
      value: "Perth Berries",
    },
    {
      key: "queensland_berries",
      value: "Queensland Berries",
    },
    {
      key: "tasmania_berries",
      value: "Tasmania Berries",
    },
  ],
  orderTypeList: [
    {
      key: "new_order",
      value: "New Order",
    },
    {
      key: "dispatch_request",
      value: "Dispatch Request",
    },
    {
      key: "factory_order",
      value: "Factory Order",
    },
    {
      key: "buffer_stock_request",
      value: "Buffer Stock Request",
    },
    {
      key: "direct_order",
      value: "Direct Order",
    },
    {
      key: "sample_request",
      value: "Sample Request",
    },
  ],
  locationsList: [
    {
      key: "",
      value: "--",
    },
    {
      key: "NSW",
      value: "NSW",
    },
    {
      key: "Perth",
      value: "Perth",
    },
    {
      key: "Queensland",
      value: "Queensland",
    },
  ],
  productFlagsChoices: [
    { label: "New Item Code Required", value: "NewItemCodeRequired" },
    { label: "New Artwork Required", value: "NewArtworkRequired" },
    { label: "Sampling Required", value: "SamplingRequired" },
  ],
  sapDocTypeChoices: [
    {
      key: "",
      value: "--",
    },
    { key: "Sales Order", value: "Sales Order" },
    { key: "Sales Quotation", value: "Sales Quotation" },
    { key: "Inventory Transfer", value: "Inventory Transfer" },
  ],
  artworkApprovedChoices: [
    {
      key: "",
      value: "--",
    },
    {
      key: "Yes",
      value: "true",
    },
    {
      key: "No",
      value: "false",
    },
  ],
  containerSizeChoices: [
    {
      key: "",
      value: "--",
    },
    {
      key: "20ft",
      value: "20ft",
    },
    {
      key: "40ft",
      value: "40ft",
    },
  ],
};
